export const SHOW_PHRASE_LIST_MODAL = 'phraseListModal/SHOW_PHRASE_LIST_MODAL';
export const SET_FILTER = 'phraseListModal/SET_FILTER';
export const SUBMIT = 'phraseListModal/SUBMIT';
export const LOAD = 'phraseListModal/LOAD';
export const HIDE_PHRASE_LIST_MODAL = 'phraseListModal/HIDE_PHRASE_LIST_MODAL';
